/**
 * Normalize stain/block value to extract required fields
 * Handles null, normalized objects, full objects, or strings
 * 
 * This function is used to ensure consistent format across the application:
 * - Frontend uses 'block' terminology
 * - Backend uses 'region' terminology
 * - Blocks: store only _id and name fields
 * - Stains: pass through content + provenance; drop schema blob only
 * 
 * @param {string|object|null} value - The value to normalize (can be null, string _id, or object with _id/name)
 * @param {string} type - Optional type hint: 'stain' or 'block' (defaults to detecting from value)
 * @returns {object|null} - Normalized object with required fields, or null
 */
export const normalizeStainBlock = (value, type = null) => {
    if (value === null || value === undefined) {
        return null;
    }
    if (typeof value === 'string') {
        // Legacy string format - treat as _id
        return { _id: value, name: null };
    }
    if (typeof value === 'object' && value._id) {
        // Detect if this is a stain (has schemaStainKey or schemaId) or block
        const isStain = type === 'stain' || (value.schemaStainKey !== undefined) || (value.schemaId !== undefined);
        
        if (isStain) {
            const { schema, ...rest } = value;
            return {
                ...rest,
                _id: rest._id,
                name: rest.name || null,
                schemaStainKey: rest.schemaStainKey || null,
                schemaId: rest.schemaId || null,
            };
        } else {
            // For blocks, extract only _id and name
            return { _id: value._id, name: value.name || null };
        }
    }
    return null;
};
